import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import formatRelativeWithOptions from 'date-fns/esm/fp/formatRelativeWithOptions/index.js';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';
import axios from 'axios';
import ErrorAwareNumberWithDcimalsField from '../../../common/inputfields/ErrorAwareNumberWithDecimalsField';

class NewRefuel extends Component {

    state = {
        refuelingAmountLiter: null,
        refuelingAmountForint: null,
        selectedRefuelingBill: {},

        errors: new Map(),
    }

    componentDidMount() {
        console.log(this.props);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/cardayrefuel';
        const requestObject = {
            "carDayId": this.props.row.privateId,
            "refuelingAmountLiter": this.state.refuelingAmountLiter,
            "refuelingAmountForint": trimSpaces(this.state.refuelingAmountForint),
            "refuelingBillId": this.state.selectedRefuelingBill?.value
        };
        console.log(requestObject);
        await handlePost(path, requestObject, this);
    };


    promiseRefuelingBillsPromise = async () => {
        const params = {
            date: this.props.row.date
        }
        const response = await axios.get('/api/refuelbills', { params })
        return response.data.map(resp => ({
            label: `${resp.billNumber} - ${resp.customerName} - ${resp.amount} Ft`,
            value: resp.privateId
        }));
    };

    handleRefuelingBillSelected = (e, v) => {
        console.log(v);
        this.setState({ selectedRefuelingBill: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="licenseNumber"
                            label="Rendszám"
                            errors={this.state.errors}
                            value={this.props.row.licenseNumber}
                            disabled
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            id="date"
                            name="date"
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.props.row.date}
                            disabled
                            onChange={v => handleChangeValue(v, "date", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberWithDcimalsField
                            name="refuelingAmountLiter"
                            label="Tankolt liter"
                            errors={this.state.errors}
                            value={this.state.refuelingAmountLiter}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            name="refuelingAmountForint"
                            label="Tankolt összeg"
                            errors={this.state.errors}
                            value={this.state.refuelingAmountForint}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-1'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedRefuelingBill}
                            defaultvale={this.state.selectedRefuelingBill}
                            getOptions={this.promiseRefuelingBillsPromise}
                            onChange={this.handleRefuelingBillSelected}
                            label={'Számla száma'}
                            required={false}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewRefuel);
